// extracted by mini-css-extract-plugin
export default {"container":"AddTransactionForm_container__E+31X","inner":"AddTransactionForm_inner__8gBbZ"};